<template>
    <div>
        <b-button-group class="btnToggleGroup mt-3">
            <b-button
                v-for="(btn, idx) in buttons"
                :key="idx"
                @click="onClick(btn.reportType)" 
                class="btnToggle"
                :class="{selected: reportTypeSelected === btn.reportType}"
                :disabled="!btn.enabled"
            >
              <i v-if="btn.icon" :class="btn.icon" aria-hidden="true"></i> {{btn.text}}
            </b-button>
        </b-button-group>
    </div>
</template>
<script>

export default {
  name: "ReportTypeSelector",
  props: {
    buttons: {
      type: Array,
      default: () => [],
    },
    reportTypeSelected: {
      type: String,
      default: () => null,
    },
  },
  methods: {
      onClick(reportTypeSelected) {
          this.$emit("clicked", reportTypeSelected);
      }
  },
}
</script>

<style scoped>
.btnToggleGroup {
    background: #E2E2E2;
    border-radius: 20px;
    height: 29px;
    min-width: 235px;
    padding: 3px;
}

.btnToggle {
    font: normal normal bold 19px/10px Lato;
    color: #727272;
    border-radius: 17px !important;
    background: none;
    border: none;
    box-shadow: none;
    font-size: 16px;
    box-shadow: none;
    display: flex;
}

.btnToggle i {
    margin-right: 9px;
    font-size: 12px;
}

.btnToggle.selected {
    color: #FFFFFF;
    background: #FF7058;
}
</style>